import NotificationPageComponent from '../../Notification/components';
import React, { useEffect, useMemo, useState } from 'react';
import API, { ROUTES } from '../../../commons/api/api';
import { useNotice } from '../../../commons/customHooks/Notification';
import { useLocation } from 'react-router-dom';

function useQuery() {
    const { search } = useLocation();
  
    return useMemo(() => new URLSearchParams(search), [search]);
  }

const NotificationPageContainer = () => {
  let query = useQuery();
  const location = useLocation();
//   console.log(location, 'locaionlocaionlocaion');
//   const [params, setParams] = useState({
//     page: 1,
//     type: query.get('type') ?? null,
//   });
  
//   const [notices, isProcessing, lastPage, currentPage] = useNotice(params);

//   const fetchMoreDataPaginate = (data) => {
//     setParams({...params, ...data});
//     // setloadMore(false)
//   };

  return (
    <NotificationPageComponent
    //   notificationData={notices?.list}
    //   lastPage={lastPage}
    //   currentPage={currentPage}
    //   loading={isProcessing}
    //   params={params}
    //   fetchMoreDataPaginate={fetchMoreDataPaginate}
    />
  );
};

export default NotificationPageContainer;
